import { async } from "regenerator-runtime";
import { req, imgServer, googlePlaceDataAPI, getWebsiteData } from "../js/config";
//import { ToHTML, ToHTMLWithFormatting } from "../js/base";
//import { async } from "regenerator-runtime";
let PageData = {};
const Initialize = async () => {
    try {
        await getPageData();
        console.log("getPageData", PageData)
    }
    catch (err) {
        console.log("🚀 ~ file: main.js:14 ~ Initialize ~ err", err)

    }

}


const getPageData = async () => {


}


const loadJavascriptNow = async () => {

    //const script = document.createElement('script');
    //script.src = 'assets/js/main.js';

    // Append to the `head` element
    //document.head.appendChild(script);
}


Initialize();

